import { memo } from 'react';
import { format, addDays, subDays } from 'date-fns';
import { fi } from 'date-fns/locale';

import Button from '@material-ui/core/Button';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

import { useStyles } from './style';

interface Props {
  date: Date;
  week: Date[];
  handleChange: (date: Date | null) => void;
}

const ServicesCalendarDayPicker: React.FC<Props> = ({
  date,
  week,
  handleChange,
}) => {
  const classes = useStyles({ count: week.length });

  const prevDay = () => {
    handleChange(subDays(date, 1));
  };

  const nextDay = () => {
    handleChange(addDays(date, 1));
  };

  return (
    <div className={classes.root}>
      <Button onClick={prevDay} classes={{ root: classes.button }}>
        <ArrowLeftIcon className={classes.icon} />
      </Button>
      <ul className={classes.ul}>
        {week.map((day) => {
          return (
            <li className={classes.li} key={day.toDateString()}>
              {format(day, 'EEEEEE d.M', { locale: fi })}
            </li>
          );
        })}
      </ul>
      <Button onClick={nextDay} classes={{ root: classes.button }}>
        <ArrowRightIcon className={classes.icon} />
      </Button>
    </div>
  );
};

export default memo(ServicesCalendarDayPicker);
